import React__default from 'react';
import { Container, Grid } from '@mui/material';
import clsx from 'clsx';
import StyledKMosaicElementDetail, { classes } from './index.styled.js';

var KMosaicElementDetail = function (_a) {
    var className = _a.className, headerElement = _a.headerElement, contentElement = _a.contentElement, headerActionElement = _a.headerActionElement, sx = _a.sx;
    return (React__default.createElement(StyledKMosaicElementDetail, { className: clsx("KMosaicElementDetail", className), sx: sx },
        React__default.createElement("div", { className: classes.header },
            React__default.createElement(Container, null,
                React__default.createElement(Grid, { container: true, className: classes.gridContainer },
                    React__default.createElement(Grid, { item: true, xs: 12, sm: 9, md: 10 }, headerElement),
                    headerActionElement && (React__default.createElement(Grid, { className: classes.headerActionElementGrid, item: true, xs: "auto" },
                        React__default.createElement("div", { className: classes.headerActionElement }, headerActionElement)))))),
        React__default.createElement("div", { className: classes.content },
            React__default.createElement(Container, null, contentElement && contentElement))));
};

export { KMosaicElementDetail, KMosaicElementDetail as default };
//# sourceMappingURL=index.js.map
